<template>
  <div class="edu-services-area ptb-100">
    <div class="container">
      <div class="edu-section-title">
        <p class="sub-title">Temel Özellikler</p>
        <h2>Neden <span class="shape02">Cvision</span> Seçmelisin</h2>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="edu-services-box">
            <div class="icon">
              <i class="bx bx-layer"></i>
            </div>
            <h3>Her Yerden Öğrenin</h3>
            <p>
              Dünyanın her yerinden, masaüstü, mobil veya tablet üzerinden internet bağlantısıyla öğrenmeye devam edin.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="edu-services-box">
            <div class="icon">
              <i class="bx bx-chalkboard"></i>
            </div>
            <h3>Uzman Eğitmenler</h3>
            <p>
              Alanında uzman eğitmenlerden, masaüstü, mobil veya tablet üzerinden internet bağlantısıyla eğitim alın.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-md-6">
          <div class="edu-services-box">
            <div class="icon">
              <i class="bx bx-support"></i>
            </div>
            <h3>7/24 Güçlü Destek</h3>
            <p>
              İstediğiniz zaman, masaüstü, mobil veya tablet üzerinden internet bağlantısıyla destek ekibimize
              ulaşabilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoreFeatures",
};
</script>